import { useMutation, useQuery } from '@tanstack/react-query';
import { orpc, useInvalidateRpcQueryFn } from '@/api/rpc/client';
import type {
  ListEntityAssociationsInput,
  CreateEntityAssociationInput,
  DeleteEntityAssociationInput,
} from '@erp/rpc';

export function useEntityAssociationsList(input: ListEntityAssociationsInput) {
  return useQuery(orpc.core.entityAssociations.list.queryOptions({ input }));
}

export function useCreateEntityAssociation() {
  const invalidateQueries = useInvalidateRpcQueryFn((orpc) => [
    orpc.core.entityAssociations.list.key(),
    orpc.accountsPayable.invoices.get.key(),
  ]);

  return useMutation(
    orpc.core.entityAssociations.create.mutationOptions({
      onSuccess: () => {
        invalidateQueries();
      },
    }),
  );
}

export function useDeleteEntityAssociation() {
  const invalidateQueries = useInvalidateRpcQueryFn((orpc) => [
    orpc.core.entityAssociations.list.key(),
    orpc.accountsPayable.invoices.get.key(),
  ]);

  return useMutation(
    orpc.core.entityAssociations.delete.mutationOptions({
      onSuccess: () => {
        invalidateQueries();
      },
    }),
  );
}
